import { createCrudService } from '../crud'

/** «Прочие» or «Кухня» (a kitchen buys at zero prices). */
export type OtherCounterpartyKind = 'other' | 'kitchen'
export const OTHER_COUNTERPARTY_KINDS: OtherCounterpartyKind[] = ['other', 'kitchen']
/** The label key of a kind (`other` would read as a plural form). */
export const otherCounterpartyKindKey = (kind: OtherCounterpartyKind) => (kind === 'other' ? 'others' : kind)

/**
 * A counterparty created by hand on Финансы › Справочники › «Контрагенты»
 * (legacy counterparties_unified «other», numbered D1, D2…).
 */
export type OtherCounterparty = {
  id: string
  company_id: string
  party_id: string
  kind: OtherCounterpartyKind
  number: string
  full_name: string
  tin: string
  phone: string
  status: 'active' | 'inactive'
  created_at: string
  updated_at: string
}

export type OtherCounterpartyInput = Pick<OtherCounterparty, 'kind' | 'full_name' | 'tin' | 'phone' | 'status'>

/** PUT replaces every field: the form always sends them all. */
export const otherCounterpartiesService = createCrudService<OtherCounterparty, OtherCounterpartyInput>('parties/other-counterparties')
